import { render, staticRenderFns } from "./kpsq.vue?vue&type=template&id=4dbda80b&scoped=true&"
import script from "./kpsq.vue?vue&type=script&lang=js&"
export * from "./kpsq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbda80b",
  null
  
)

export default component.exports